import styled, { css } from 'styled-components';
import { StyledButton } from '../../chat/Button/Styled';

export const StyledImageCropWrapper = styled.div<{ displayLarge?: boolean }>`
  margin-top: 1.25rem;

  ${(props) =>
    props.displayLarge &&
    css`
      margin-top: 1rem;
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      justify-content: flex-end;

      ${StyledCropButtonWrapper} {
        flex-shrink: 0;
        margin: 0 0 1.25rem 0;
        align-self: flex-start;
      }

      ${StyledButton} {
        border: 2px solid transparent;
        padding: 0.5rem 1.5rem 0.5rem 1rem;
        font-size: ${(props) => props.theme.fontSizes.h5.fontSize};
        line-height: 1.2;

        .ch-icon + .ch-label {
          margin-left: 1rem;
        }
      }

      ${({ theme }) => theme.mediaQueries.min.md} {
        flex-direction: row-reverse;
        align-items: flex-start;

        ${StyledCropButtonWrapper} {
          margin: 0 1.5rem 0 0;
        }

        ${StyledButton} {
          font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
        }
      }
    `}

  ${({ theme }) => theme.mediaQueries.min.md} {
    margin-top: 0.75rem;
    display: flex;
    align-items: flex-end;
  }
`;

export const StyledCropButtonWrapper = styled.div`
  display: flex;
  margin-top: 0.75rem;

  ${({ theme }) => theme.mediaQueries.min.md} {
    margin-top: 0;
    margin-left: 1rem;
  }
`;
